"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'whatsapp.settingsForm.titleCreate': 'Add WhatsApp Phone Number',
    'whatsapp.settingsForm.titleEdit': 'Edit WhatsApp Phone Number',
    'whatsapp.settingsForm.back': 'Back',
    'whatsapp.settingsForm.loadFailed': 'Failed to load WhatsApp configuration.',
};
